export enum CaseAction {
  acknowledge = "sendAcknowledgeMessage",
  chatMessage = "sendChatMessage",
  markArrived = "markArrived",
  setAsLeftED = "setAsLeftED",
  assignRoom = "assignRoom",
  activateProtocol = "activateProtocol",
  recallProtocol = "recallProtocol",
  activateProtocolStep = "activateProtocolStep",
  recallProtocolStep = "recallProtocolStep",
  invite = "invite",
  gettingStatUsersToInvite = "statUsersToInvite",
  report = "report",
  retrievingCase = "retrievingCase",
  retrievingCasesList = "retrievingCasesList",
  downloadMedia = "downloadMedia",
  updateExtras = "updateExtras",
  updatePatientIFTPickup = "updatePatientIFTPickup",
  updatePatientIFTDelivery = "updatePatientIFTDelivery",
  updateIftCaseEvent = "updateIftCaseEvent",
  updateMihCaseEvent = "updateMihCaseEvent",
  retrievingReportList = "retrievingReportList",
  retrievingCalendarEvents = "retrievingCalendarEvents",
  createHandoffFeedback = "createHandoffFeedback",
}

export enum HospitalCaseAction {
  createCase = "createCase",
  editCase = "editCase",
  createIftCase = "createIftCase",
  createMihCase = "createMihCase",
}

export type StateId = {
  action: CaseAction | HospitalCaseAction;
  caseId?: string;
  actionId?: string;
};
